import { useState, useEffect } from "react";
import "./index.css";

export default function BeerCounter() {
  const [beers, setBeers] = useState(0);
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const startDate = new Date("2025-08-12T12:00:00+02:00"); // Mezzogiorno, 12 Agosto 2025 CEST

    const update = () => {
      const now = new Date();
      const diffMs = now - startDate;
      const diffMinutes = Math.floor(diffMs / 1000 / 60);
      setBeers(diffMinutes >= 0 ? diffMinutes : 0);
      setCurrentTime(
        now.toLocaleTimeString("it-IT", { timeZone: "Europe/Berlin", hour12: false })
      );
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="counter-container">
      <h1>🍺 Contatore di Birre</h1>
      <p>Birre accumulate da</p>
      <p>12 Agosto, mezzogiorno (CEST)</p>
      <div className="counter-value">
        {beers} 🍺
      </div>
      <p className="clock">Ora attuale: {currentTime} (CEST)</p>
    </div>
  );
}
